






















































































































































































    
import { alert } from 'devextreme/ui/dialog';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxEditing, DxColumn, DxHeaderFilter, DxStateStoring } from 'devextreme-vue/data-grid';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxButton } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import { CommentService } from '../../service/CommentService';
import { QuestelServicesClient } from '@questelservices/common';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { InfractionTypeDto } from '@/models/infractions/InfractionTypeDto';
import { PhaseTypeService } from '@/service/PhaseTypeService';
import { InfractionService } from '@/service/InfractionService';
import RespondToComment from '@/components/activity-planner/respond-to-comment.vue'
import { MatterWorkTypeEnum } from '@/models/matter-work/MatterWorkTypeEnum';
import { RespondEnum  } from '@/models/comments/RespondEnum';
import { CommentAutoTextData, EmailDetail } from '@/models/comments/CommentAutoText';
import { CommentDto } from '@/models/comments/CommentDto';
import DateTime from '../../utilities/DateTime';
import MatterDetails from '@/components/matter/matter-details.vue';
import { DxDataGrid, DxSummary, DxTotalItem } from 'devextreme-vue/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { ViewMatterInAuditingDto } from '@/models/matter-work/ViewMatterInAuditingDto';

    @Component({
        components: {
            DxButton,
            DxColumn,
            DxEditing,
            DxScrollView,
            DxStateStoring,
            DxToolbarItem,
            RespondToComment,
            MatterDetails,
            Popup,
            DxHeaderFilter,
            DxDataGrid,
            DxSummary,
            DxTotalItem
        }
    })
    export default class CommentsGrid extends Vue {
        public $refs: Vue['$refs'] & {
            commentDatagrid?: DxDataGrid;
        } = {};

        @Prop()
        showAllComments!: boolean;  

        @Prop()
        replyToAgentId!: Guid;

        @Prop()
        forwardToClientId!: Guid;

        get getReplyToAgentId() {
            return this.replyToAgentId;
        }

        get getForwardToClientId() {
            return this.forwardToClientId;
        }

        private readonly matterDetailsRef: string = 'matterDetails';
        dataGridCustomStoreOption: CustomStore;
        private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');
        commentService: CommentService;
        phaseTypes: Array<PhaseTypeDto> = [];
        infractionTypes: Array<InfractionTypeDto> = [];        
        canEscalate: boolean = false;
        showRespondEmail: boolean = false;
        emailCC: string = '';
        emailBcc: string = ''
        emailBody: string = '';
        emailSubject: string = '';
        emailTo: string = '';
        respondType: RespondEnum = RespondEnum.DoNotSend;
        commentData: CommentAutoTextData | {} = {};
        commentEmail : EmailDetail | {} = {}
        private showDialog: boolean = false;
        private emailBodyText: string = '';
        private popupTitle: string = '';
        private commentCount: number=0;

        allCommentsDataStoreOptions: DevExpress.data.CustomStoreOptions = {
            key: 'CommentId',
            load: loadOptions => this.commentService.searchAll(loadOptions),
            update: (key, values) => this.commentService.edit(key, values)
        };

        tieredCommentsDataStoreOptions: DevExpress.data.CustomStoreOptions = {
            key: 'CommentId',
            load: loadOptions => this.commentService.search(loadOptions),
            update: (key, values) => this.commentService.edit(key, values)
        };

        updateCommentCount() {
            this.commentCount=this.dataGrid.getTotalSummaryValue("CommentCount");
        }

        get showEscalateColumn() : boolean {
            if (this.showAllComments) {
                return false;
            }

            if (this.canEscalate) {
                return true;
            }

            return false;
        }

        constructor() {
            super();    
            this.commentService = new CommentService();            
            this.dataGridCustomStoreOption = this.showAllComments ? new CustomStore(this.allCommentsDataStoreOptions) 
                                                                  : new CustomStore(this.tieredCommentsDataStoreOptions);                                                                
        }          

        created() {
            this.loadData();            
        }
        
        async loadData()
        {
            let phaseTypeService = new PhaseTypeService();
            this.phaseTypes = await phaseTypeService.getAll();

            let infractionService = new InfractionService();
            this.infractionTypes = await infractionService.GetAllInfractionTypes();

            this.canEscalate = await this.commentService.getCanEscalate();
            this.applyIssueResolvedFilter();
        }

        onCellPrepared(e: any) {
            if(e.rowType === 'data' && e.column.caption === 'Phase/Infraction') {
                let phaseType = this.phaseTypes.filter(t => t.PhaseName === e.row.data.PhaseName)[0];                
                if (phaseType) {
                    e.cellElement.style['background-color'] = phaseType.RgbHex;
                }
            }           
        }

        private get dataGrid(): DevExpress.ui.dxDataGrid {
            return (this.$refs.commentDatagrid as any).instance;
        }

        refreshDataGrid(): void {
            this.dataGrid.refresh();
        }
        private applyIssueResolvedFilter() {
            this.dataGrid.columnOption('IssueResolved', 'filterValue', false);
        }     

        rowUpdating(e: any) {
            // Add back any data not edited
            e.newData = Object.assign({}, e.oldData, e.newData);
        }

        escalateComment(comment: CommentDto){
            if (comment.Tier < 3) {
                comment.Tier++;
            }

            this.commentService.edit(comment.CommentId, comment)
                .then(_ => {
                    this.refreshDataGrid();
            });
        }

        private get matterDetails() {
          return this.$refs[this.matterDetailsRef] as MatterDetails;
        }

        prepareContextMenu(e: any): void {
            if (e.target === 'content' && e.row &&  e.row.rowType === 'data') {
                let hasAgentReponse = e.row.data.ResponseEmailId === null ? false : true;
                let hasForwardedToClient = e.row.data.ForwardEmailId === null ? false : true;
                
                e.items = [
                    {
                        text: 'View Matter',
                        onItemClick: () => this.showMatterDetails(e.row.data)
                    },
                    {
                        text: 'Open Matter in Auditing',
                        onItemClick: () => this.openMatterInAuditing(e.row.data)
                    },
                    {
                        text: 'Respond to Agent',
                        onItemClick: () => this.openResponseEmail(e.row.data, RespondEnum.ToAgent)
                    },
                    {
                        text: 'Forward Agent Comment to Client',
                        onItemClick: () => this.openResponseEmail(e.row.data, RespondEnum.ToClient)
                    },
                    {
                        text: 'View Correspondence', disabled: e.row.data.ResponseEmailId === null
                    },
                    {
                        text: 'View Response History',
                        items: [
                            {
                                text: "Respond to Agent",
                                onItemClick: () => {
                                    this.popupTitle = "Response History - Respond to Agent";
                                    this.openResponseHistory(e.row.data.ResponseEmailId);
                                },
                                disabled: !hasAgentReponse
                            },
                            {
                                text: "Forwarded to Client",   
                                onItemClick: () => {
                                    this.popupTitle = "Response History - Forwarded to Client";
                                    this.openResponseHistory(e.row.data.ForwardEmailId);
                                },
                                disabled: !hasForwardedToClient
                            }
                        ],
                        disabled: hasAgentReponse !== true && hasForwardedToClient !== true
                    }
                ];
            }
        }

        private showMatterDetails(comment: CommentDto) {
          this.matterDetails.matter = {
            MatterId: comment.MatterId,
            MatterName: comment.MatterName,
            ClientName: comment.ClientName,
            CountryCode: comment.CountryCode
          };

          this.matterDetails.show();
        }

        private openMatterInAuditing(comment: CommentDto) {                    
            let notes = `RE: ${comment.AgentName}, ${comment.MatterName}`;   
            
            let viewMatterInAuditingDto: ViewMatterInAuditingDto = {
                MatterId: comment.MatterId,
                Notes: notes
            };

            this.client.getPostData<Guid>('/api/MatterWorks/view-matter-in-auditing', viewMatterInAuditingDto)
                .then(result => {
                    let route = this.$router.resolve({ name: 'auditing', params: { id: result as string }, query: {'cases': '1'} });
                    window.open(route.href);
                })
                .catch(err => {
                    alert('Error opening matter in Auditing', 'Error');
                });            
        }

        openResponseEmail(e: CommentDto, to: RespondEnum)  {            
            this.showRespondEmail = true;
            this.respondType = to;
            if(to == RespondEnum.ToAgent) {
                this.emailSubject = `Re: ${e.CommentEmail.Subject}`;
                this.emailTo = e.CommentEmail.From;
                this.emailCC = e.CommentEmail.Cc;
            }
            else {
                this.emailSubject = `Fw: ${e.CommentEmail.Subject}`;
                this.emailTo = e.CommentEmail.ClientEmail;
            }
            this.commentData  = {
                ClientName  : e.ClientName,
                AgentName : e.AgentName,
                MatterName : e.MatterName,
                CountryCode : e.CountryCode,
                IssueName : e.IssueName,
                AgentReponseDate : e.AgentResponseDate,
                AgentComment : e.AgentComment,
            }
            this.commentEmail = {
                Cc : e.CommentEmail.Cc,
                Bcc : e.CommentEmail.Bcc,
                Subject : e.CommentEmail.Subject,
                From : e.CommentEmail.From,
                Sent: e.AgentResponseDate,
                To: e.CommentEmail.To,
                Body : e.CommentEmail.Body,
                FileUploadId : e.CommentEmail.FileUploadId,
                CommentId : e.CommentId
            }
        }

        onRespondCommentHidden() {
            this.showRespondEmail = false;
            this.respondType = RespondEnum.DoNotSend;
            this.emailTo = "";
            this.emailSubject = "";
            this.commentData = {
                ClientName  : "",
                AgentName : "",
                MatterName : "",
                CountryCode : "",
                IssueName : "",
                AgentReponseDate : new DateTime(),
                AgentComment : "",
            };
            this.commentEmail = {
                Cc : "",
                Bcc : "",
                Subject : "",
                From : "",
                Sent: new DateTime(),
                To: "",
                Body : "",
                FileUploadId : "",
                CommentId: ""
            }
        }
        
        private async openResponseHistory(emailId: Guid): Promise<void> {            
            this.showDialog = true;
            this.emailBodyText = await this.commentService.getResponseHistory(emailId);
        }

        private closePopup(): void {
            this.showDialog = false;
        }
    }
